(function () {
  const EDITION_META = {
    digital: {
      key: "digital",
      label: "Digital Download",
      badge: "Digital album available now",
      kicker: "Digital edition",
      title: "The full 15-track album in digital form",
      description:
        "Get the entire album as a high-quality digital release built for headphones, speakers, and full-volume replay. Available immediately in MP3 and WAV after purchase, with the PDF booklet included.",
      summary:
        "15-track full album download in MP3 and WAV, available immediately after purchase, with the PDF booklet included.",
      specs: [
        "15-track full album",
        "Includes the full 15-track digital album files",
        "PDF booklet included",
        "Immediate MP3 and WAV delivery",
      ],
      shippingKey: "digital",
      tracklistMode: "cd-digital",
      storyLabel: "Available now",
    },
    cd: {
      key: "cd",
      label: "CD Digipak",
      badge: "Collector CD edition",
      kicker: "Physical edition",
      title: "A 4-panel digipak",
      description:
        "The CD edition carries the full 15-track album inside a 4-panel digipak with pocket, a 20-page color booklet, a transparent tray, and the digital album files included.",
      summary:
        "4-panel digipak CD with booklet, transparent tray, and included digital files.",
      specs: [
        "4-panel digipak with pocket",
        "20-page color booklet",
        "Transparent tray",
        "Includes the full 15-track digital album files",
      ],
      shippingKey: "cd",
      tracklistMode: "cd-digital",
      storyLabel: "Full-length physical release",
    },
    vinyl: {
      key: "vinyl",
      label: "Limited Red Marble Vinyl",
      badge: "Limited red marble pressing",
      kicker: "Collector pressing",
      title: "A limited red marble vinyl",
      description:
        "The vinyl edition delivers the curated 11-track sequence on a 12-inch, 140g red marble pressing with a full-color insert, with the full digital album files included.",
      summary:
        "12-inch limited red marble vinyl, 140g, with full-color insert and included digital files.",
      specs: [
        "12-inch limited red marble vinyl",
        "140g pressing",
        "Full-color insert",
        "11-track vinyl sequence",
        "Includes the full 15-track digital album files",
      ],
      shippingKey: "vinyl",
      tracklistMode: "vinyl",
      storyLabel: "Premium physical centerpiece",
    },
    bundle: {
      key: "bundle",
      label: "Vinyl + CD Bundle",
      badge: "Complete physical bundle",
      kicker: "Bundle edition",
      title: "Vinyl and CD together",
      description:
        "Get the limited red marble vinyl and the full-length CD digipak together, with the full digital album files included.",
      summary:
        "Limited red marble vinyl, CD digipak, and included digital files in one complete set.",
      specs: [
        "12-inch limited red marble vinyl",
        "4-panel digipak CD with pocket",
        "Full-color insert and 20-page booklet",
        "11-track vinyl sequence",
        "Includes the full 15-track digital album files",
      ],
      shippingKey: "bundle",
      tracklistMode: "vinyl",
      storyLabel: "Complete physical set",
    },
  };

  const TRACKLISTS = {
    cdDigital: [
      "Soundcheck",
      "Umbrella Street",
      "Swing Thing Fling",
      "Intergalactic March",
      "Roots",
      "Fish Named Beanie (Steel Drum)",
      "Goodmorningen",
      "Universe in a Bruise",
      "My Favorite Rain",
      "My Favorite Thunderstorm",
      "Home",
      "Heart Garden",
      "Every Breath You Take (Guitar & Drum)",
      "Careless Whisper",
      "Fish Named Beanie (Solo Guitar)",
    ],
    vinylA: [
      "Umbrella Street — 3:37",
      "Swing Thing Fling — 3:20",
      "Intergalactic March — 4:32",
      "Roots — 5:32",
      "Fish Named Beanie (Steel Drum) — 3:35",
      "Goodmorningen — 4:28",
    ],
    vinylB: [
      "Universe in a Bruise — 4:24",
      "My Favorite Rain — 2:17",
      "My Favorite Thunderstorm — 4:15",
      "Home — 6:24",
      "Heart Garden — 6:53",
    ],
  };

  const DEFAULT_VIDEO_BLURBS = {
    "Careless Whisper":
      "Released alongside FINAL BOSS, this reimagined version returns to the piece that originally introduced many listeners to Alex's music. Recrafted on the Frankenstein Guitar, it adds a deeper sense of restraint, detail, groove, and feel, seamlessly fitting into the album's sonic world.",
    "Umbrella Street":
      "The first strike: melodic, infectious, and groove-heavy, loaded with Alex's signature detuning moves that redefine the acoustic guitar and introduce the world of FINAL BOSS.",
    "Intergalactic March":
      "Driven by a Star Wars DVD, prepared guitar rattle and marching snare rhythms, this track channels Alex's boldness like no one else, making it the album's most cinematic and relentless moment.",
    "Rain & Thunderstorm":
      "An epic two-part suite that evolves from quiet, rainy tension into a storm of thunderous force, blending metal influences with power and melody. A reflection of Alex's guitar journey over the past ten years, captured in a single monumental piece.",
  };

  const PROMO_FALLBACK = "FINALBOSS15";
  const SPOTIFY_ALBUM_URL = "https://open.spotify.com/album/066e7SZfJMSMkPyZYOEDs7";
  const STREAMING_MORE_URL = "https://album.link/us/i/1881286113";
  const APPLE_MUSIC_ALBUM_URL = "https://music.apple.com/us/album/final-boss/1881286113";
  const ITUNES_ALBUM_URL =
    "https://geo.music.apple.com/us/album/_/1881286113?mt=1&app=itunes&ls=1&at=1000lHKX&ct=api_http&itscg=30200&itsct=odsl_m";
  const YOUTUBE_MUSIC_ALBUM_URL =
    "https://music.youtube.com/playlist?list=OLAK5uy_mIvJNG_hcrAmoiK9ZRnIRqc64iz3U-UIc";
  const CARELESS_WHISPER_VIDEO_URL = "https://www.youtube.com/watch?v=Nrurt9ESpGY";
  const TABS_BUNDLE = {
    image:
      "https://cdn.shopify.com/s/files/1/0279/0578/5988/files/tabs-bundle-mockup-final_copy_cba8b1a3-6bcc-4266-b8f7-f626952c5c3c.webp?v=1777022733",
    url: "/products/final-boss-complete-tabs-bundle",
  };
  const SECRET_BOSS_CODE = "SECRETBOSS20";
  const STREAMING_LINKS = [
    { label: "Spotify", url: SPOTIFY_ALBUM_URL },
    { label: "Apple Music", url: APPLE_MUSIC_ALBUM_URL },
    { label: "TIDAL", url: "https://listen.tidal.com/album/502769540" },
    { label: "Yandex Music", url: "https://music.yandex.ru/album/40884079" },
    { label: "iTunes", url: ITUNES_ALBUM_URL },
    { label: "Deezer", url: STREAMING_MORE_URL },
    { label: "Qobuz", url: STREAMING_MORE_URL },
    { label: "YouTube Music", url: YOUTUBE_MUSIC_ALBUM_URL },
    { label: "Amazon Music", url: STREAMING_MORE_URL },
  ];
  const CTA_LABELS = {
    digital: "Get digital album",
    cd: "Buy CD",
    vinyl: "Buy vinyl",
    bundle: "Buy bundle",
  };

  function escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function ensureTrailingPeriod(value) {
    const text = String(value ?? "").trim();

    if (!text) return "";
    if (/[.!?…]$/.test(text)) return text;

    return text + ".";
  }

  function slugify(value) {
    return String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function resolveEditionKey(title) {
    const normalized = String(title ?? "").toLowerCase();

    if (normalized.includes("bundle")) return "bundle";
    if (normalized.includes("vinyl")) return "vinyl";
    if (normalized.includes("cd")) return "cd";
    if (normalized.includes("digital")) return "digital";

    return "";
  }

  function getYouTubeId(input) {
    if (!input) return "";

    const raw = String(input).trim();
    const shortMatch = raw.match(/youtu\.be\/([A-Za-z0-9_-]{11})/);
    if (shortMatch) return shortMatch[1];

    const embedMatch = raw.match(/embed\/([A-Za-z0-9_-]{11})/);
    if (embedMatch) return embedMatch[1];

    const watchMatch = raw.match(/[?&]v=([A-Za-z0-9_-]{11})/);
    if (watchMatch) return watchMatch[1];

    if (/^[A-Za-z0-9_-]{11}$/.test(raw)) return raw;

    return "";
  }

  function buildSpotifyEmbedUrl(rawUrl, explicitUrl) {
    if (explicitUrl) return explicitUrl;
    if (!rawUrl) return "";

    try {
      const url = new URL(rawUrl, window.location.origin);
      if (!url.hostname.includes("spotify.com")) return "";

      const cleanedPath = url.pathname.replace(/^\/embed\//, "/").replace(/^\/+/, "");
      const baseUrl = "https://open.spotify.com/embed/" + cleanedPath;

      if (url.search) return baseUrl + url.search;
      return baseUrl;
    } catch (error) {
      return "";
    }
  }

  function getSpotifyAlbumUrl(config) {
    return config.spotifyAlbumUrl || SPOTIFY_ALBUM_URL;
  }

  function compactGallery(items) {
    const seen = new Set();

    return (items || []).filter(function (item) {
      const value = String(item || "").trim();
      if (!value || seen.has(value)) return false;
      seen.add(value);
      return true;
    });
  }

  function getLocalReleaseDate(rawValue) {
    const value = String(rawValue || "").trim();
    if (!value) return new Date(NaN);

    const dateMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateMatch) {
      const year = Number(dateMatch[1]);
      const monthIndex = Number(dateMatch[2]) - 1;
      const day = Number(dateMatch[3]);
      return new Date(year, monthIndex, day, 0, 0, 0, 0);
    }

    return new Date(value);
  }

  function formatMoney(cents, currency) {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency || "EUR",
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  function formatReleaseDate(dateString) {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "April 24, 2026";

    return new Intl.DateTimeFormat(undefined, {
      month: "long",
      day: "numeric",
      year: "numeric",
    }).format(date);
  }

  function normalizeVideos(configVideos) {
    const seen = new Set();
    const launchVideos = [
      {
        title: "Careless Whisper",
        subtitle: "Focus single",
        url: CARELESS_WHISPER_VIDEO_URL,
      },
    ].concat(configVideos || []);

    return launchVideos
      .map(function (video) {
        const youtubeId = getYouTubeId(video.url);
        if (!youtubeId) return null;
        if (seen.has(youtubeId)) return null;
        seen.add(youtubeId);

        return {
          title: video.title,
          subtitle: video.subtitle || "Single release",
          blurb: video.blurb || DEFAULT_VIDEO_BLURBS[video.title] || "",
          youtubeId: youtubeId,
        };
      })
      .filter(Boolean);
  }

  function normalizeVariants(product) {
    return (product.variants || [])
      .map(function (variant) {
        const editionKey = resolveEditionKey(variant.title);
        if (!editionKey || !EDITION_META[editionKey]) return null;

        return {
          id: variant.id,
          title: variant.title,
          available: variant.available !== false,
          price: Number(variant.price || 0),
          compareAtPrice: Number(variant.compareAtPrice || 0),
          editionKey: editionKey,
        };
      })
      .filter(Boolean);
  }

  function renderVariantButtons(variants, scope) {
    return variants
      .map(function (variant) {
        const meta = EDITION_META[variant.editionKey];
        const iconLabel =
          variant.editionKey === "digital"
            ? "Digital download icon"
            : variant.editionKey === "cd"
              ? "CD icon"
              : variant.editionKey === "bundle"
                ? "Bundle icon"
                : "Vinyl icon";
        const iconMarkup =
          variant.editionKey === "digital"
            ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3v10.2l3.1-3.1 1.4 1.4-5.5 5.5-5.5-5.5 1.4-1.4 3.1 3.1V3z"/><path d="M5 19h14v2H5z"/></svg>'
            : variant.editionKey === "cd"
              ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9m0 15.8A6.8 6.8 0 1 1 18.8 12 6.81 6.81 0 0 1 12 18.8"/><circle cx="12" cy="12" r="2.2"/></svg>'
              : variant.editionKey === "bundle"
                ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 7.2 12 3l7 4.2v9.6L12 21l-7-4.2zm7-1.9L8.6 7.4 12 9.4l3.4-2zM7 9.1v6.5l4 2.4v-6.8zm10 0-4 2.1V18l4-2.4z"/></svg>'
                : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9m0 15.8A6.8 6.8 0 1 1 18.8 12 6.81 6.81 0 0 1 12 18.8"/><circle cx="12" cy="12" r="2.2"/><path d="M16.7 7.3a1.3 1.3 0 1 0 1.3 1.3 1.3 1.3 0 0 0-1.3-1.3"/></svg>';
        return (
          '<button type="button" class="fbp__variant-pill" data-fbp-variant-button="' +
          escapeHtml(scope || "global") +
          '" data-variant-id="' +
          escapeHtml(variant.id) +
          '" data-edition-key="' +
          escapeHtml(variant.editionKey) +
          '" aria-pressed="false">' +
          '<span class="fbp__variant-main">' +
          '<span class="fbp__variant-icon" aria-label="' +
          escapeHtml(iconLabel) +
          '">' +
          iconMarkup +
          "</span>" +
          '<span class="fbp__variant-copy">' +
          '<span class="fbp__variant-label">' +
          escapeHtml(meta.label) +
          "</span>" +
          '<span class="fbp__variant-price">' +
          escapeHtml(formatMoney(variant.price, variant.currency)) +
          "</span>" +
          "</span>" +
          "</span>" +
          "</button>"
        );
      })
      .join("");
  }

  function renderHeroVariantSelect(variants) {
    return (
      '<div class="fbp__hero-select" data-fbp-hero-select>' +
      '<span class="fbp__mini-kicker">Edition</span>' +
      '<button type="button" class="fbp__hero-select-button" data-fbp-hero-select-toggle aria-haspopup="listbox" aria-expanded="false">' +
      '<span data-fbp-hero-select-label></span>' +
      '<span class="fbp__hero-select-arrow" aria-hidden="true"></span>' +
      "</button>" +
      '<div class="fbp__hero-select-menu" data-fbp-hero-select-menu hidden>' +
      '<div class="fbp__hero-select-list" role="listbox" aria-label="Edition">' +
      variants
        .map(function (variant) {
          const meta = EDITION_META[variant.editionKey];
          return (
            '<button type="button" class="fbp__hero-select-option" role="option" data-fbp-variant-select="hero" data-edition-key="' +
            escapeHtml(variant.editionKey) +
            '" data-variant-id="' +
            escapeHtml(variant.id) +
            '"' +
            (variant.available ? "" : " disabled aria-disabled=\"true\"") +
            ' aria-selected="false">' +
            '<span>' +
            escapeHtml(meta.label) +
            "</span>" +
            "<strong>" +
            escapeHtml(formatMoney(variant.price, variant.currency)) +
            "</strong>" +
            (variant.available ? "" : "<small>Sold out</small>") +
            "</button>"
          );
        })
        .join("") +
      "</div>" +
      "</div>" +
      '<select class="fbp__hero-select-native" data-fbp-variant-native-select="hero" aria-label="Edition">' +
      variants
        .map(function (variant) {
          const meta = EDITION_META[variant.editionKey];
          return (
            '<option value="' +
            escapeHtml(variant.editionKey) +
            '">' +
            escapeHtml(meta.label + " - " + formatMoney(variant.price, variant.currency)) +
            "</option>"
          );
        })
        .join("") +
      "</select>" +
      "</div>"
    );
  }

  function renderQuantityControl(scope) {
    const labelId = "fbp-quantity-label-" + scope;
    return (
      '<div class="fbp__quantity" data-fbp-quantity="' +
      escapeHtml(scope) +
      '">' +
      '<label id="' +
      labelId +
      '" class="fbp__quantity-label" for="fbp-quantity-input-' +
      escapeHtml(scope) +
      '">Qty</label>' +
      '<div class="fbp__quantity-stepper">' +
      '<button type="button" class="fbp__quantity-button" data-fbp-quantity-decrease aria-label="Decrease quantity">-</button>' +
      '<input id="fbp-quantity-input-' +
      escapeHtml(scope) +
      '" class="fbp__quantity-input" data-fbp-quantity-input name="quantity" type="number" min="1" step="1" inputmode="numeric" value="1" aria-labelledby="' +
      labelId +
      '">' +
      '<button type="button" class="fbp__quantity-button" data-fbp-quantity-increase aria-label="Increase quantity">+</button>' +
      "</div>" +
      "</div>"
    );
  }

  function renderVideoCards(videos) {
    return videos
      .map(function (video) {
        return (
          '<article class="fbp__video-card" data-fbp-video-card>' +
          '<div class="fbp__video-media">' +
          '<button type="button" class="fbp__video-button" data-fbp-video-trigger data-video-id="' +
          escapeHtml(video.youtubeId) +
          '" data-video-title="' +
          escapeHtml(video.title) +
          '">' +
          '<span class="fbp__video-poster">' +
          '<img src="https://i.ytimg.com/vi/' +
          escapeHtml(video.youtubeId) +
          '/hqdefault.jpg" alt="' +
          escapeHtml(video.title) +
          ' video thumbnail" loading="lazy">' +
          '<span class="fbp__video-overlay"></span>' +
          '<span class="fbp__video-play"><span></span></span>' +
          "</span>" +
          "</button>" +
          '<div class="fbp__video-embed" data-fbp-video-embed hidden></div>' +
          "</div>" +
          '<div class="fbp__video-copy">' +
          '<p class="fbp__mini-kicker">' +
          escapeHtml(video.subtitle) +
          "</p>" +
          "<h3>" +
          escapeHtml(video.title) +
          "</h3>" +
          "<p>" +
          escapeHtml(video.blurb) +
          "</p>" +
          "</div>" +
          "</article>"
        );
      })
      .join("");
  }

  function renderStreamingLinks(className) {
    return (
      '<ul class="' +
      className +
      '" aria-label="Streaming links">' +
      STREAMING_LINKS.map(function (link) {
        return (
          '<li><a href="' +
          escapeHtml(link.url) +
          '" target="_blank" rel="noopener noreferrer">' +
          '<span>' +
          escapeHtml(link.label) +
          "</span>" +
          "<small>Open</small>" +
          "</a></li>"
        );
      }).join("") +
      "</ul>"
    );
  }

  function renderTracklistPanel(mode) {
    if (mode === "vinyl") {
      return (
        '<div class="fbp__tracklist-stack">' +
        '<div class="fbp__tracklist-block fbp__tracklist-block--full">' +
        '<p class="fbp__tracklist-side">Side A · 25:04</p>' +
        "<ol>" +
        TRACKLISTS.vinylA.map(function (track) {
          return "<li>" + escapeHtml(track) + "</li>";
        }).join("") +
        "</ol>" +
        "</div>" +
        '<div class="fbp__tracklist-block fbp__tracklist-block--full">' +
        '<p class="fbp__tracklist-side">Side B · 24:14</p>' +
        "<ol>" +
        TRACKLISTS.vinylB.map(function (track) {
          return "<li>" + escapeHtml(track) + "</li>";
        }).join("") +
        "</ol>" +
        "</div>" +
        "</div>"
      );
    }

    return (
      '<div class="fbp__tracklist-block fbp__tracklist-block--full">' +
      '<p class="fbp__tracklist-side">15 tracks · 62:27</p>' +
      "<ol>" +
      TRACKLISTS.cdDigital.map(function (track) {
        return "<li>" + escapeHtml(track) + "</li>";
      }).join("") +
      "</ol>" +
      "</div>"
    );
  }

  function renderTracklistAccordion(mode, title, expanded) {
    const hint =
      mode === "vinyl" ? "View vinyl tracklist" : mode === "cd-digital" ? "View tracklist" : "View tracklist";

    return (
      '<div class="fbp__tracklist-dropdown' +
      (expanded ? " is-open" : "") +
      '">' +
      '<button type="button" class="fbp__tracklist-toggle" data-fbp-inline-tracklist-toggle aria-expanded="' +
      String(expanded) +
      '">' +
      '<span class="fbp__tracklist-toggle-copy">' +
      '<span class="fbp__tracklist-toggle-title">' +
      escapeHtml(title) +
      "</span>" +
      '<small class="fbp__tracklist-toggle-hint">' +
      escapeHtml(hint) +
      "</small>" +
      "</span>" +
      '<span class="fbp__tracklist-toggle-arrow" aria-hidden="true">▾</span>' +
      "</button>" +
      '<div class="fbp__tracklist-dropdown-panel" data-fbp-inline-tracklist-panel' +
      (expanded ? "" : " hidden") +
      ">" +
      renderTracklistPanel(mode) +
      "</div>" +
      "</div>"
    );
  }

  function isTracklistTriggerLine(editionKey, item) {
    if (editionKey === "vinyl") return item === "11-track vinyl sequence";
    if (editionKey === "bundle") {
      return item === "11-track vinyl sequence" || item === "Includes the full 15-track digital album files";
    }
    return item === "Includes the full 15-track digital album files";
  }

  function getTracklistButtonLabel(key) {
    if (key === "vinyl") return "Vinyl tracklist";
    if (key === "bundle") return "Bundle tracklists";
    if (key === "cd") return "CD tracklist";
    return "Digital tracklist";
  }

  function getTracklistDialogTitle(key) {
    if (key === "vinyl") return "Vinyl tracklist";
    if (key === "bundle") return "Bundle tracklists";
    if (key === "cd") return "CD tracklist";
    return "Digital tracklist";
  }

  function createYouTubeEmbed(videoId, title) {
    const iframe = document.createElement("iframe");
    const params = new URLSearchParams({
      autoplay: "1",
      controls: "1",
      rel: "0",
      playsinline: "1",
    });
    iframe.src = "https://www.youtube-nocookie.com/embed/" + videoId + "?" + params.toString();
    iframe.title = title || "Final Boss video";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframe.allowFullscreen = true;
    return iframe;
  }

  function renderHeroTitle(config) {
    const productTitle = escapeHtml(config.product.title || "Final Boss");
    const heroLogo = config.images && config.images.heroLogo ? escapeHtml(config.images.heroLogo) : "";

    if (heroLogo) {
      return (
        '<img class="fbp__hero-logo" src="' +
        heroLogo +
        '" alt="' +
        productTitle +
        '" loading="eager" decoding="async">'
      );
    }

    return '<h1 class="fbp__hero-title" data-title="' + productTitle + '"><span>' + productTitle + "</span></h1>";
  }

  function createMarkup(config, variants, videos, spotifyEmbedUrl) {
    const promoCode = config.promoCode || PROMO_FALLBACK;
    const spotifyAlbumUrl = getSpotifyAlbumUrl(config);
    const tabsBundle = Object.assign({}, TABS_BUNDLE, config.tabsBundle || {});
    const tabsBundlePrice = Number(tabsBundle.price || 0);
    const tabsBundleCompareAtPrice = Number(tabsBundle.compareAtPrice || 0);
    const tabsBundlePriceMarkup =
      tabsBundlePrice > 0
        ? '<p class="fbp__tabs-price" aria-label="Tabs bundle price">' +
          '<span>' +
          escapeHtml(formatMoney(tabsBundlePrice, config.product.currency)) +
          "</span>" +
          (tabsBundleCompareAtPrice > tabsBundlePrice
            ? '<span class="fbp__tabs-compare">' +
              escapeHtml(formatMoney(tabsBundleCompareAtPrice, config.product.currency)) +
              "</span>"
            : "") +
          "</p>"
        : "";
    const heroBlurb = ensureTrailingPeriod(
      config.heroBlurb ||
        "Alexandr Misko pushes the Frankenstein Guitar to its limit on a record built from detuning, percussion, melody, and impact."
    );
    const storyQuote =
      config.storyQuote ||
      "This album is the culmination of everything I’ve been working toward as a musician, guitarist, and composer.";

    return (
      '<div class="fbp__shell">' +
      '<section class="fbp__hero fbp__reveal is-visible" data-fbp-hero style="--fbp-hero-image:url(\'' +
      escapeHtml(config.images.heroBackground || "") +
      "\')\">" +
      '<div class="fbp__grain"></div>' +
      '<div class="fbp__hero-grid">' +
      '<div class="fbp__hero-copy">' +
      '<p class="fbp__eyebrow">Album out now</p>' +
      '<button type="button" class="fbp__boss-hotspot" data-fbp-boss-hotspot aria-label="Reveal boss meter"></button>' +
      '<div class="fbp__boss-ui" data-fbp-boss-ui hidden>' +
      '<div class="fbp__boss-copy">' +
      '<span class="fbp__boss-label">Boss HP</span>' +
      '<span class="fbp__boss-status" data-fbp-boss-status>100 / 100</span>' +
      "</div>" +
      '<div class="fbp__boss-bar" aria-hidden="true">' +
      '<span class="fbp__boss-fill" data-fbp-boss-fill></span>' +
      "</div>" +
      '<p class="fbp__boss-note" data-fbp-boss-note>Stay sharp.</p>' +
      "</div>" +
      renderHeroTitle(config) +
      '<p class="fbp__release-line">Available now</p>' +
      '<p class="fbp__hero-text">' +
      escapeHtml(heroBlurb) +
      "</p>" +
      '<div class="fbp__purchase-card">' +
      '<div class="fbp__purchase-copy">' +
      '<p class="fbp__mini-kicker">Choose your edition</p>' +
      '<p class="fbp__purchase-blurb" data-fbp-selected-summary="hero"></p>' +
      '<p class="fbp__hero-offer">Save 15% with <strong>' +
      escapeHtml(promoCode) +
      "</strong></p>" +
      "</div>" +
      '<form class="fbp__buy-form fbp__buy-form--inline" data-fbp-form="hero" method="post" action="/cart/add">' +
      '<input type="hidden" name="id" value="" data-fbp-variant-input="hero">' +
      '<div class="fbp__hero-choice-row">' +
      '<div class="fbp__variant-grid fbp__variant-grid--hero" role="group" aria-label="Edition">' +
      renderVariantButtons(variants, "hero") +
      "</div>" +
      renderQuantityControl("hero") +
      "</div>" +
      '<div class="fbp__buy-row">' +
      '<div class="fbp__price-row">' +
      '<div class="fbp__price-stack">' +
      '<span class="fbp__price" data-fbp-price="hero"></span>' +
      '<span class="fbp__compare" data-fbp-compare="hero" hidden></span>' +
      "</div>" +
      '<p class="fbp__price-note" data-fbp-hero-note="hero"></p>' +
      "</div>" +
      '<button type="submit" class="fbp__primary-button" data-fbp-submit="hero">Buy now</button>' +
      "</div>" +
      "</form>" +
      '<ul class="fbp__purchase-trust" aria-label="Purchase details">' +
      "<li>Secure checkout</li>" +
      "<li>Digital files included with every physical edition</li>" +
      "<li>US Premium shipping includes tracking, insurance, taxes and duties</li>" +
      "</ul>" +
      "</div>" +
      "</div>" +
      '<div class="fbp__hero-stage">' +
      '<div class="fbp__stage-card">' +
      '<p class="fbp__stage-badge" data-fbp-stage-badge></p>' +
      '<div class="fbp__stage-glow"></div>' +
      '<img class="fbp__stage-image" data-fbp-stage-image src="" alt="" loading="eager">' +
      '<div class="fbp__stage-controls">' +
      '<button type="button" class="fbp__stage-nav" data-fbp-stage-prev aria-label="Previous image">‹</button>' +
      '<div class="fbp__stage-dots" data-fbp-stage-dots></div>' +
      '<button type="button" class="fbp__stage-nav" data-fbp-stage-next aria-label="Next image">›</button>' +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      '<div class="fbp__hero-band">' +
      '<div class="fbp__deal-row">' +
      '<div class="fbp__promo-panel" data-fbp-secret-offer>' +
      '<div class="fbp__promo-copy">' +
      '<p class="fbp__mini-kicker">FINAL BOSS offer</p>' +
      "<h2>Save 15% on FINAL BOSS</h2>" +
      '<ul class="fbp__promo-perks">' +
      "<li><strong>15% off</strong> with code <span>" +
      escapeHtml(promoCode) +
      "</span></li>" +
      "</ul>" +
      "</div>" +
      '<div class="fbp__promo-actions">' +
      '<button type="button" class="fbp__secondary-button fbp__promo-code-button" data-fbp-copy-code data-code="' +
      escapeHtml(promoCode) +
      '">' +
      escapeHtml(promoCode) +
      "</button>" +
      "</div>" +
      '<p class="fbp__discount-status" data-fbp-copy-status aria-live="polite"></p>' +
      "</div>" +
      '<div class="fbp__countdown-wrap">' +
      '<div class="fbp__countdown-shell fbp__release-status">' +
      '<p class="fbp__mini-kicker">Released April 24, 2026</p>' +
      "<h2>Final Boss is out now</h2>" +
      '<p><button type="button" class="fbp__inline-jump" data-fbp-scroll-to="stream">Stream the album</button>, <button type="button" class="fbp__inline-jump" data-fbp-scroll-to="editions">choose your edition</button>, or take the full <button type="button" class="fbp__inline-jump" data-fbp-scroll-to="tabs">tab collection</button> into the practice room.</p>' +
      "</div>" +
      '<p class="fbp__countdown-note" data-fbp-countdown-note>Album available now.</p>' +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</section>" +

      '<section class="fbp__section fbp__section--tabs fbp__reveal" data-fbp-scroll-section="tabs">' +
      '<div class="fbp__tabs-shell">' +
      '<div class="fbp__tabs-copy">' +
      '<p class="fbp__eyebrow">Complete tabs bundle</p>' +
      "<h2>Complete FINAL BOSS Tabs Bundle</h2>" +
      '<figure class="fbp__tabs-visual">' +
      '<img src="' +
      escapeHtml(TABS_BUNDLE.image) +
      '" alt="Final Boss Complete Tabs Bundle mockup" loading="lazy">' +
      "</figure>" +
      "<p>All 14 FINAL BOSS guitar tabs in one package, with PDF, Guitar Pro, and WAV files for each song off the album. Carefully crafted as detailed, song-by-song guides showcasing Alex's most ambitious tab work to date.</p>" +
      '<p class="fbp__tabs-note">Special launch price for a limited time. Includes the full guitar tab collection for the album, excluding the steel-drum-only piece. Individual tabs are also available for purchase on the website.</p>' +
      '<div class="fbp__tabs-action">' +
      tabsBundlePriceMarkup +
      '<a class="fbp__primary-button fbp__tabs-button" href="' +
      escapeHtml(tabsBundle.url) +
      '" target="_blank" rel="noopener noreferrer">View tabs bundle</a>' +
      "</div>" +
      "</div>" +
      "</div>" +
      "</section>" +

      '<section class="fbp__section fbp__section--videos fbp__reveal">' +
      '<div class="fbp__section-head">' +
      '<p class="fbp__eyebrow">Singles in rotation</p>' +
      '<h2>ENTER <span class="fbp__heading-accent">FINAL BOSS</span> THROUGH THE SINGLES</h2>' +
      "</div>" +
      '<div class="fbp__carousel-shell">' +
      '<button type="button" class="fbp__carousel-nav" data-fbp-carousel-prev aria-label="Scroll videos left">‹</button>' +
      '<div class="fbp__carousel-track" data-fbp-carousel-track>' +
      renderVideoCards(videos) +
      "</div>" +
      '<button type="button" class="fbp__carousel-nav" data-fbp-carousel-next aria-label="Scroll videos right">›</button>' +
      "</div>" +
      "</section>" +

      '<section class="fbp__section fbp__section--tracklist fbp__reveal" data-fbp-scroll-section="editions">' +
      '<div class="fbp__section-head">' +
      '<p class="fbp__eyebrow">Inside the record</p>' +
      "<h2>Choose your Final Boss format</h2>" +
      '<p>Choose a format to see what you get and when.</p>' +
      "</div>" +
      '<div class="fbp__tracklist-intro">' +
      '<div class="fbp__variant-grid fbp__variant-grid--tracklist">' +
      renderVariantButtons(variants, "showcase") +
      "</div>" +
      '<div class="fbp__edition-panel fbp__edition-panel--tracklist">' +
      '<div class="fbp__edition-copy">' +
      '<p class="fbp__mini-kicker" data-fbp-edition-kicker></p>' +
      "<h3 data-fbp-edition-title></h3>" +
      "<p data-fbp-edition-description></p>" +
      '<ul class="fbp__spec-list" data-fbp-spec-list></ul>' +
      '<div class="fbp__edition-buy-row">' +
      '<div class="fbp__price-row fbp__price-row--edition">' +
      '<div class="fbp__price-stack">' +
      '<span class="fbp__price" data-fbp-price="showcase"></span>' +
      '<span class="fbp__compare" data-fbp-compare="showcase" hidden></span>' +
      "</div>" +
      "</div>" +
      '<form class="fbp__buy-form fbp__buy-form--edition" data-fbp-form="showcase" method="post" action="/cart/add">' +
      '<input type="hidden" name="id" value="" data-fbp-variant-input="showcase">' +
      renderQuantityControl("showcase") +
      '<button type="submit" class="fbp__primary-button" data-fbp-submit="showcase">Buy now</button>' +
      "</form>" +
      "</div>" +
      '<div class="fbp__edition-note">' +
      '<p class="fbp__mini-kicker">Shipping</p>' +
      "<p data-fbp-edition-shipping></p>" +
      "</div>" +
      "</div>" +
      '<figure class="fbp__edition-visual fbp__edition-visual--tracklist">' +
      '<img data-fbp-edition-image src="" alt="" loading="lazy">' +
      "</figure>" +
      "</div>" +
      "</div>" +
      "</section>" +

      '<section id="stream-final-boss" class="fbp__section fbp__section--spotify fbp__reveal" data-fbp-scroll-section="stream">' +
      '<div class="fbp__spotify-shell">' +
      '<div class="fbp__spotify-copy">' +
      '<p class="fbp__eyebrow">Listen everywhere</p>' +
      "<h2>Stream Final Boss</h2>" +
      "<p>The full album is live. Choose your platform below and step into the world of FINAL BOSS.</p>" +
      renderStreamingLinks("fbp__stream-links") +
      "</div>" +
      '<div class="fbp__spotify-card">' +
      (spotifyEmbedUrl
        ? '<iframe src="' +
          escapeHtml(spotifyEmbedUrl) +
          '" title="Final Boss on Spotify" loading="lazy" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>'
        : '<div class="fbp__spotify-fallback"><p>Spotify album link available in Shopify settings.</p></div>') +
      "</div>" +
      "</div>" +
      "</section>" +

      '<section class="fbp__section fbp__section--story fbp__reveal">' +
      '<div class="fbp__story-panel">' +
      '<div class="fbp__story-badge">' +
      '<figure class="fbp__story-portrait">' +
      '<img src="' +
      escapeHtml(config.images.portrait || config.images.coverArtwork || "") +
      '" alt="Alexandr Misko portrait" loading="lazy">' +
      "</figure>" +
      '<div class="fbp__story-identity-copy">' +
      '<p class="fbp__mini-kicker">Alexandr Misko</p>' +
      '<span>On Final Boss</span>' +
      "</div>" +
      "</div>" +
      '<div class="fbp__story-quote-shell">' +
      '<span class="fbp__story-quote-glyph" aria-hidden="true">“</span>' +
      '<blockquote class="fbp__story-quote-mark" data-fbp-story-quote data-text="' +
      escapeHtml(storyQuote) +
      '"></blockquote>' +
      '<span class="fbp__story-quote-glyph fbp__story-quote-glyph--end" aria-hidden="true">”</span>' +
      "</div>" +
      "</div>" +
      "</section>" +

      '<section class="fbp__section fbp__section--terms fbp__reveal">' +
      '<div class="fbp__terms-grid">' +
      '<aside class="fbp__lock-panel">' +
      '<p class="fbp__mini-kicker">Choose your edition</p>' +
      "<h3>Get Final Boss now</h3>" +
      '<p class="fbp__lock-copy" data-fbp-lock-copy="footer"></p>' +
      '<div class="fbp__variant-grid fbp__variant-grid--compact">' +
      renderVariantButtons(variants, "footer") +
      "</div>" +
      '<div class="fbp__price-row fbp__price-row--lock">' +
      '<div class="fbp__price-stack">' +
      '<span class="fbp__price" data-fbp-price="footer"></span>' +
      '<span class="fbp__compare" data-fbp-compare="footer" hidden></span>' +
      "</div>" +
      "</div>" +
      '<form class="fbp__buy-form" data-fbp-form="footer" method="post" action="/cart/add">' +
      '<input type="hidden" name="id" value="" data-fbp-variant-input="footer">' +
      renderQuantityControl("footer") +
      '<button type="submit" class="fbp__primary-button" data-fbp-submit="footer">Buy now</button>' +
      "</form>" +
      "</aside>" +
      "</div>" +
      "</section>" +

      '<div class="fbp__lightbox" data-fbp-lightbox hidden>' +
      '<div class="fbp__lightbox-backdrop" data-fbp-lightbox-close></div>' +
      '<div class="fbp__lightbox-dialog" role="dialog" aria-modal="true" aria-label="Dialog" data-fbp-lightbox-dialog>' +
      '<button type="button" class="fbp__lightbox-close" data-fbp-lightbox-close>Close</button>' +
      '<div class="fbp__lightbox-copy" data-fbp-lightbox-copy hidden>' +
      '<p class="fbp__mini-kicker">Tracklist</p>' +
      '<h3 data-fbp-lightbox-title></h3>' +
      "</div>" +
      '<div class="fbp__lightbox-frame" data-fbp-lightbox-frame></div>' +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  function init(root, config) {
    const queryParams = new URLSearchParams(window.location.search);
    const requestedEdition = (queryParams.get("edition") || "").toLowerCase();
    const paidLanding = queryParams.get("landing") === "paid";

    if (paidLanding) {
      document.body.classList.add("fbp-paid-traffic");
    }

    const variants = normalizeVariants(config.product).map(function (variant) {
      return Object.assign({}, variant, {
        currency: config.product.currency || "EUR",
      });
    });
    const variantsByKey = variants.reduce(function (map, variant) {
      map[variant.editionKey] = variant;
      return map;
    }, {});
    const videos = normalizeVideos(config.videos);
    const spotifyEmbedUrl = buildSpotifyEmbedUrl(getSpotifyAlbumUrl(config), config.spotifyEmbedUrl);

    if (!variants.length) {
      root.innerHTML = '<div class="fbp__empty">No matching variants were found for Final Boss.</div>';
      return;
    }

    root.innerHTML = createMarkup(config, variants, videos, spotifyEmbedUrl);

    const availableVariant =
      variants.find(function (variant) {
        return variant.available;
      }) || variants[0];

    const requestedVariant = variantsByKey[requestedEdition];
    const initialEdition = requestedVariant && requestedVariant.available ? requestedEdition : "";
    let activeHeroEdition = initialEdition || (variantsByKey.vinyl ? "vinyl" : availableVariant.editionKey);
    let activeShowcaseEdition = initialEdition || (variantsByKey.cd ? "cd" : variantsByKey.bundle ? "bundle" : availableVariant.editionKey);
    let activeFooterEdition = initialEdition || (variantsByKey.bundle ? "bundle" : variantsByKey.digital ? "digital" : availableVariant.editionKey);
    let countdownTimer = null;

    const stageImage = root.querySelector("[data-fbp-stage-image]");
    const editionImage = root.querySelector("[data-fbp-edition-image]");
    const stageBadge = root.querySelector("[data-fbp-stage-badge]");
    const stageDots = root.querySelector("[data-fbp-stage-dots]");
    const editionKicker = root.querySelector("[data-fbp-edition-kicker]");
    const editionTitle = root.querySelector("[data-fbp-edition-title]");
    const editionDescription = root.querySelector("[data-fbp-edition-description]");
    const editionShipping = root.querySelector("[data-fbp-edition-shipping]");
    const editionNote = root.querySelector(".fbp__edition-note");
    const specList = root.querySelector("[data-fbp-spec-list]");
    const countdownNote = root.querySelector("[data-fbp-countdown-note]");
    const countdownShell = root.querySelector("[data-fbp-countdown-shell]");
    const promoPanel = root.querySelector("[data-fbp-secret-offer]");
    const lightbox = root.querySelector("[data-fbp-lightbox]");
    const lightboxDialog = root.querySelector("[data-fbp-lightbox-dialog]");
    const lightboxCopy = root.querySelector("[data-fbp-lightbox-copy]");
    const lightboxFrame = root.querySelector("[data-fbp-lightbox-frame]");
    const lightboxTitle = root.querySelector("[data-fbp-lightbox-title]");
    const carouselTrack = root.querySelector("[data-fbp-carousel-track]");
    const hero = root.querySelector("[data-fbp-hero]");
    const bossHotspot = root.querySelector("[data-fbp-boss-hotspot]");
    const bossUi = root.querySelector("[data-fbp-boss-ui]");
    const bossFill = root.querySelector("[data-fbp-boss-fill]");
    const bossStatus = root.querySelector("[data-fbp-boss-status]");
    const bossNote = root.querySelector("[data-fbp-boss-note]");
    const termsSection = root.querySelector(".fbp__section--terms");
    let activeGalleryIndex = 0;
    let inlineTracklistOpen = false;
    let bossHp = 100;
    let bossRevealed = false;
    const bossEasterEggActive = false;
    let secretOfferClicks = 0;
    let secretOfferTimer = null;
    let secretOfferUnlocked = false;
    let stageRotateTimer = null;
    let discountToastTimer = null;
    let storyQuoteTimer = null;

    function nodesByAttr(name, scope) {
      return root.querySelectorAll("[" + name + '="' + scope + '"]');
    }

    function getEditionImage(key) {
      if (key === "vinyl" && config.images.vinylMockup) return config.images.vinylMockup;
      if (key === "cd" && config.images.cdMockup) return config.images.cdMockup;
      if (key === "bundle") {
        return config.images.bundleMockup || config.images.vinylMockup || config.images.cdMockup || config.images.digitalArtwork || "";
      }
      if (key === "digital" && config.images.digitalArtwork) return config.images.digitalArtwork;
      if (config.images.coverArtwork) return config.images.coverArtwork;
      return config.images.heroBackground || "";
    }

    function getEditionGallery(key) {
      const configured = config.galleries && config.galleries[key] ? compactGallery(config.galleries[key]) : [];
      if (configured.length) return configured;
      if (key === "bundle") {
        return compactGallery([config.images.bundleMockup || getEditionImage(key)]);
      }
      return compactGallery([getEditionImage(key)]);
    }

    function getLockCopy(key) {
      if (key === "bundle") {
        return "The complete physical bundle pairs the red marble vinyl with the CD digipak and digital files. Shipping options and rates are shown at checkout.";
      }
      if (key === "vinyl") {
        return "The limited red marble vinyl includes the curated vinyl sequence and digital files. Shipping options and rates are shown at checkout.";
      }
      if (key === "cd") {
        return "The CD digipak includes the full-length physical edition and digital files. Shipping options and rates are shown at checkout.";
      }
      return "Get the full album as MP3 and WAV files, available immediately after purchase, with the PDF booklet included.";
    }

    function getHeroShippingLine(key) {
      if (key === "bundle" || key === "vinyl" || key === "cd") return "";
      return "Digital album and PDF booklet available immediately.";
    }

    function getShippingNote(key) {
      const meta = EDITION_META[key];
      if (!meta) return "";
      const note = (config.shippingNotes && config.shippingNotes[meta.shippingKey]) || "";
      if (key !== "digital" || !note || /booklet/i.test(note)) return note;
      return note.replace(/\.$/, "") + ", with the PDF booklet included.";
    }

    function showDiscountToast(text) {
      if (!text) return;
      let toast = root.querySelector("[data-fbp-discount-toast]");

      if (!toast) {
        toast = document.createElement("div");
        toast.className = "fbp__discount-toast";
        toast.setAttribute("data-fbp-discount-toast", "");
        toast.setAttribute("role", "status");
        toast.setAttribute("aria-live", "polite");
        root.appendChild(toast);
      }

      toast.textContent = text;
      toast.classList.add("is-visible");

      if (discountToastTimer) {
        window.clearTimeout(discountToastTimer);
      }

      discountToastTimer = window.setTimeout(function () {
        toast.classList.remove("is-visible");
      }, 2600);
    }

    function startStoryQuoteTypewriter(scope) {
      const storyQuote = (scope || root).querySelector("[data-fbp-story-quote]");
      if (!storyQuote || storyQuote.getAttribute("data-typed") === "true") return;

      const fullText = storyQuote.getAttribute("data-text") || "";
      if (!fullText) return;

      storyQuote.setAttribute("data-typed", "true");

      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        storyQuote.textContent = fullText;
        storyQuote.classList.remove("is-typing");
        return;
      }

      let index = 0;
      storyQuote.textContent = "";
      storyQuote.classList.add("is-typing");

      function step() {
        index += 1;
        storyQuote.textContent = fullText.slice(0, index);

        if (index >= fullText.length) {
          storyQuote.classList.remove("is-typing");
          storyQuoteTimer = null;
          return;
        }

        const nextDelay = fullText.charAt(index - 1).match(/[,.]/) ? 44 : 24;
        storyQuoteTimer = window.setTimeout(step, nextDelay);
      }

      storyQuoteTimer = window.setTimeout(step, 180);
    }

    function updateBossUi() {
      if (!bossEasterEggActive) return;
      if (!bossUi || !bossFill || !bossStatus || !bossNote) return;
      bossFill.style.width = bossHp + "%";
      bossStatus.textContent = bossHp + " / 100";
      if (bossHp <= 0) {
        bossUi.classList.add("is-defeated");
        bossStatus.textContent = "0 / 100";
        bossNote.textContent = "Boss defeated. Album unlocked.";
      } else {
        bossUi.classList.remove("is-defeated");
        bossNote.textContent = bossHp <= 35 ? "Final phase. Keep clicking editions." : "Click an edition to deal damage.";
      }
    }

    function revealBossUi() {
      if (!bossEasterEggActive) return;
      if (!bossUi) return;
      bossRevealed = true;
      bossUi.hidden = false;
      bossUi.classList.add("is-visible");
      updateBossUi();
    }

    function damageBoss() {
      if (!bossEasterEggActive) return;
      if (!bossRevealed) return;
      if (bossHp <= 0) return;
      bossHp = Math.max(0, bossHp - 17);
      updateBossUi();
    }

    function renderStageDots(gallery, activeIndex) {
      if (!stageDots) return;

      stageDots.innerHTML = gallery
        .map(function (_, index) {
          const isActive = index === activeIndex;
          return (
            '<button type="button" class="fbp__stage-dot' +
            (isActive ? " is-active" : "") +
            '" data-fbp-stage-dot data-index="' +
            index +
            '" aria-label="Show image ' +
            (index + 1) +
            '" aria-pressed="' +
            String(isActive) +
            '"></button>'
          );
        })
        .join("");

      root.querySelectorAll("[data-fbp-stage-dot]").forEach(function (button) {
        button.addEventListener("click", function () {
          const nextIndex = Number(button.getAttribute("data-index") || 0);
          updateStageImage(activeHeroEdition, nextIndex);
          startStageRotation();
        });
      });
    }

    function updateStageImage(key, nextIndex) {
      const gallery = getEditionGallery(key);
      if (!gallery.length) return;

      const boundedIndex = ((nextIndex % gallery.length) + gallery.length) % gallery.length;
      const imageUrl = gallery[boundedIndex];
      const meta = EDITION_META[key];

      activeGalleryIndex = boundedIndex;
      stageImage.classList.add("is-swapping");

      window.setTimeout(function () {
        stageImage.src = imageUrl;
        stageImage.alt = meta.label + " gallery image " + (boundedIndex + 1);
        stageImage.classList.remove("is-swapping");
      }, 120);

      renderStageDots(gallery, boundedIndex);
      root.querySelectorAll("[data-fbp-stage-prev], [data-fbp-stage-next]").forEach(function (button) {
        button.disabled = gallery.length <= 1;
      });
    }

    function startStageRotation() {
      if (stageRotateTimer) {
        window.clearInterval(stageRotateTimer);
        stageRotateTimer = null;
      }

      if (getEditionGallery(activeHeroEdition).length <= 1) return;

      stageRotateTimer = window.setInterval(function () {
        updateStageImage(activeHeroEdition, activeGalleryIndex + 1);
      }, 8000);
    }

    function stabilizeViewportPosition(anchorButton, anchorTop) {
      if (!anchorButton || typeof anchorTop !== "number" || !anchorButton.isConnected) return;

      window.requestAnimationFrame(function () {
        if (!anchorButton.isConnected) return;
        const deltaY = anchorButton.getBoundingClientRect().top - anchorTop;
        if (Math.abs(deltaY) > 1) {
          window.scrollBy(0, deltaY);
        }
      });
    }

    function updateHeroEdition(key) {
      const variant = variantsByKey[key];
      const meta = EDITION_META[key];
      if (!variant || !meta) return;
      activeHeroEdition = key;
      root.setAttribute("data-active-hero-edition", key);
      root.querySelectorAll('[data-fbp-variant-button="hero"]').forEach(function (button) {
        const isActive = button.getAttribute("data-edition-key") === key;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });
      nodesByAttr("data-fbp-variant-native-select", "hero").forEach(function (select) {
        select.value = key;
      });
      root.querySelectorAll('[data-fbp-variant-select="hero"]').forEach(function (button) {
        const isActive = button.getAttribute("data-edition-key") === key;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-selected", String(isActive));
      });
      root.querySelectorAll("[data-fbp-hero-select-label]").forEach(function (node) {
        node.textContent = meta.label + " - " + formatMoney(variant.price, variant.currency);
      });
      nodesByAttr("data-fbp-variant-input", "hero").forEach(function (input) {
        input.value = variant.id;
      });
      nodesByAttr("data-fbp-price", "hero").forEach(function (node) {
        node.textContent = formatMoney(variant.price, variant.currency);
      });
      nodesByAttr("data-fbp-compare", "hero").forEach(function (node) {
        if (variant.compareAtPrice > variant.price) {
          node.hidden = false;
          node.textContent = formatMoney(variant.compareAtPrice, variant.currency);
        } else {
          node.hidden = true;
          node.textContent = "";
        }
      });
      nodesByAttr("data-fbp-selected-summary", "hero").forEach(function (node) {
        node.textContent = meta.summary;
      });
      nodesByAttr("data-fbp-hero-note", "hero").forEach(function (node) {
        const heroNote = getHeroShippingLine(key);
        node.hidden = !heroNote;
        node.textContent = heroNote;
      });
      nodesByAttr("data-fbp-submit", "hero").forEach(function (button) {
        button.disabled = !variant.available;
        const ctaLabel = CTA_LABELS[key] || "Buy " + meta.label;
        button.textContent = variant.available ? ctaLabel : meta.label + " sold out";
      });
      stageBadge.textContent = meta.badge;
      updateStageImage(key, 0);
      startStageRotation();
    }

    function updateShowcaseEdition(key, anchorButton, anchorTop) {
      const variant = variantsByKey[key];
      const meta = EDITION_META[key];
      if (!variant || !meta) return;
      const imageUrl = getEditionImage(key);
      const shippingNote = getShippingNote(key);

      activeShowcaseEdition = key;
      root.setAttribute("data-active-edition", key);

      editionImage.classList.add("is-swapping");

      window.setTimeout(function () {
        editionImage.src = imageUrl;
        editionImage.alt = meta.label + " product mockup";
        editionKicker.textContent = meta.kicker;
        editionTitle.textContent = meta.title;
        editionDescription.textContent = meta.description;
        editionShipping.textContent = shippingNote;
        if (editionNote) {
          editionNote.hidden = !shippingNote;
        }
        inlineTracklistOpen = false;
        specList.innerHTML = "";
        meta.specs.forEach(function (item, index) {
          const li = document.createElement("li");
          const isTracklistLine = isTracklistTriggerLine(key, item);
          if (isTracklistLine) {
            const tracklistMode = key === "bundle" && item === "Includes the full 15-track digital album files"
              ? "cd-digital"
              : meta.tracklistMode;
            li.className = "fbp__spec-list-item fbp__spec-list-item--tracklist";
            li.innerHTML = renderTracklistAccordion(tracklistMode, item, inlineTracklistOpen);
          } else {
            li.innerHTML = escapeHtml(item);
          }
          specList.appendChild(li);
        });
        editionImage.classList.remove("is-swapping");
        stabilizeViewportPosition(anchorButton, anchorTop);
      }, 120);

      root.querySelectorAll('[data-fbp-variant-button="showcase"]').forEach(function (button) {
        const isActive = String(button.getAttribute("data-variant-id")) === String(variant.id);
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });

      nodesByAttr("data-fbp-variant-input", "showcase").forEach(function (input) {
        input.value = variant.id;
      });

      nodesByAttr("data-fbp-price", "showcase").forEach(function (node) {
        node.textContent = formatMoney(variant.price, variant.currency);
      });

      nodesByAttr("data-fbp-compare", "showcase").forEach(function (node) {
        if (variant.compareAtPrice > variant.price) {
          node.hidden = false;
          node.textContent = formatMoney(variant.compareAtPrice, variant.currency);
        } else {
          node.hidden = true;
          node.textContent = "";
        }
      });

      nodesByAttr("data-fbp-submit", "showcase").forEach(function (button) {
        button.disabled = !variant.available;
        const ctaLabel = CTA_LABELS[key] || "Buy " + meta.label;
        button.textContent = variant.available ? ctaLabel : meta.label + " sold out";
      });
      stabilizeViewportPosition(anchorButton, anchorTop);
    }

    function updateFooterEdition(key) {
      const variant = variantsByKey[key];
      const meta = EDITION_META[key];
      if (!variant || !meta) return;
      const shippingNote = getShippingNote(key);
      activeFooterEdition = key;
      root.querySelectorAll('[data-fbp-variant-button="footer"]').forEach(function (button) {
        const isActive = String(button.getAttribute("data-variant-id")) === String(variant.id);
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });
      nodesByAttr("data-fbp-variant-input", "footer").forEach(function (input) {
        input.value = variant.id;
      });
      nodesByAttr("data-fbp-price", "footer").forEach(function (node) {
        node.textContent = formatMoney(variant.price, variant.currency);
      });
      nodesByAttr("data-fbp-compare", "footer").forEach(function (node) {
        if (variant.compareAtPrice > variant.price) {
          node.hidden = false;
          node.textContent = formatMoney(variant.compareAtPrice, variant.currency);
        } else {
          node.hidden = true;
          node.textContent = "";
        }
      });
      nodesByAttr("data-fbp-shipping-note", "footer").forEach(function (node) {
        node.textContent = shippingNote;
      });
      nodesByAttr("data-fbp-submit", "footer").forEach(function (button) {
        button.disabled = !variant.available;
        const ctaLabel = CTA_LABELS[key] || "Buy " + meta.label;
        button.textContent = variant.available ? ctaLabel : meta.label + " sold out";
      });
      nodesByAttr("data-fbp-lock-copy", "footer").forEach(function (node) {
        node.textContent = getLockCopy(key);
      });
    }

    function updateCountdown() {
      if (!root.querySelector("[data-fbp-days]")) {
        if (countdownNote) countdownNote.textContent = "Album available now.";
        return;
      }

      const releaseDate = getLocalReleaseDate(config.releaseDateISO);
      if (Number.isNaN(releaseDate.getTime())) return;

      const now = new Date();
      const diff = releaseDate.getTime() - now.getTime();
      const clamped = Math.max(0, diff);
      const totalSeconds = Math.floor(clamped / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      root.querySelector("[data-fbp-days]").textContent = String(days).padStart(2, "0");
      root.querySelector("[data-fbp-hours]").textContent = String(hours).padStart(2, "0");
      root.querySelector("[data-fbp-minutes]").textContent = String(minutes).padStart(2, "0");
      root.querySelector("[data-fbp-seconds]").textContent = String(seconds).padStart(2, "0");

      if (diff <= 0) {
        countdownNote.textContent = "Final Boss is out now.";
      } else {
        countdownNote.textContent = "Release date: " + formatReleaseDate(config.releaseDateISO) + ".";
      }
    }

    function unlockSecretOffer() {
      if (!promoPanel || secretOfferUnlocked) return;
      const copyStatus = promoPanel.querySelector("[data-fbp-copy-status]");
      const codeButton = promoPanel.querySelector("[data-fbp-copy-code]");

      secretOfferUnlocked = true;
      promoPanel.classList.add("is-secret-unlocked");

      if (codeButton) {
        codeButton.setAttribute("data-code", SECRET_BOSS_CODE);
        codeButton.textContent = SECRET_BOSS_CODE;
      }

      if (copyStatus) {
        copyStatus.textContent =
          "Persistence was worth it. Bonus unlocked: 20% off with " + SECRET_BOSS_CODE + ".";
        copyStatus.classList.add("is-visible", "is-secret");
      }
    }

    function stopInlineVideos(exceptCard) {
      root.querySelectorAll("[data-fbp-video-card]").forEach(function (card) {
        if (exceptCard && card === exceptCard) return;
        const button = card.querySelector("[data-fbp-video-trigger]");
        const embed = card.querySelector("[data-fbp-video-embed]");
        if (embed) {
          embed.replaceChildren();
          embed.hidden = true;
        }
        if (button) {
          button.hidden = false;
        }
        card.classList.remove("is-playing");
      });
    }

    function playInlineVideo(button, videoId, title) {
      const card = button.closest("[data-fbp-video-card]");
      if (!card) return;
      const embed = card.querySelector("[data-fbp-video-embed]");
      if (!embed) return;

      stopInlineVideos(card);
      embed.replaceChildren(createYouTubeEmbed(videoId, title));
      embed.hidden = false;
      button.hidden = true;
      card.classList.add("is-playing");
    }

    function openTracklistLightbox(key) {
      const mode = EDITION_META[key] ? EDITION_META[key].tracklistMode : "cd-digital";
      const title = getTracklistDialogTitle(key);
      lightboxDialog.setAttribute("aria-label", title);
      lightboxDialog.classList.add("is-tracklist");
      lightboxCopy.hidden = false;
      lightboxTitle.textContent = title;
      lightboxFrame.innerHTML = '<div class="fbp__tracklist-popover">' + renderTracklistPanel(mode) + "</div>";
      lightbox.hidden = false;
      document.body.classList.add("fbp-lightbox-open");
    }

    function closeLightbox() {
      lightboxFrame.replaceChildren();
      lightboxCopy.hidden = true;
      lightboxDialog.classList.remove("is-tracklist");
      lightboxDialog.setAttribute("aria-label", "Dialog");
      lightbox.hidden = true;
      document.body.classList.remove("fbp-lightbox-open");
    }

    function normalizeSectionKey(key) {
      const normalized = String(key || "")
        .replace(/^#/, "")
        .trim()
        .toLowerCase();

      if (normalized === "stream-final-boss" || normalized === "streaming") return "stream";
      return normalized;
    }

    function scrollToPageSection(key, behavior) {
      key = normalizeSectionKey(key);
      const target = root.querySelector('[data-fbp-scroll-section="' + key + '"]');
      if (!target) return;
      target.scrollIntoView({
        behavior: behavior ||
          (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth"),
        block: "start",
      });
    }

    function scrollToInitialHash() {
      if (!window.location.hash) return;
      const key = normalizeSectionKey(window.location.hash);
      if (!key) return;
      window.requestAnimationFrame(function () {
        scrollToPageSection(key, "auto");
      });
    }

    root.querySelectorAll("[data-fbp-variant-button]").forEach(function (button) {
      button.addEventListener("click", function () {
        const scope = button.getAttribute("data-fbp-variant-button") || "";
        const editionKey = button.getAttribute("data-edition-key") || "";
        const anchorTop = button.getBoundingClientRect().top;
        if (!editionKey) return;
        damageBoss();
        if (scope === "hero") updateHeroEdition(editionKey);
        if (scope === "showcase") updateShowcaseEdition(editionKey, button, anchorTop);
        if (scope === "footer") updateFooterEdition(editionKey);
      });
    });

    root.querySelectorAll("[data-fbp-hero-select-toggle]").forEach(function (button) {
      button.addEventListener("click", function () {
        const wrapper = button.closest("[data-fbp-hero-select]");
        const menu = wrapper ? wrapper.querySelector("[data-fbp-hero-select-menu]") : null;
        const isOpen = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isOpen));
        if (menu) menu.hidden = isOpen;
      });
    });

    nodesByAttr("data-fbp-variant-select", "hero").forEach(function (button) {
      button.addEventListener("click", function () {
        const editionKey = button.getAttribute("data-edition-key") || "";
        if (!editionKey) return;
        const wrapper = button.closest("[data-fbp-hero-select]");
        const toggle = wrapper ? wrapper.querySelector("[data-fbp-hero-select-toggle]") : null;
        const menu = wrapper ? wrapper.querySelector("[data-fbp-hero-select-menu]") : null;
        damageBoss();
        updateHeroEdition(editionKey);
        if (toggle) toggle.setAttribute("aria-expanded", "false");
        if (menu) menu.hidden = true;
      });
    });

    nodesByAttr("data-fbp-variant-native-select", "hero").forEach(function (select) {
      select.addEventListener("change", function () {
        const editionKey = select.value;
        if (!editionKey) return;
        damageBoss();
        updateHeroEdition(editionKey);
      });
    });

    document.addEventListener("click", function (event) {
      root.querySelectorAll("[data-fbp-hero-select]").forEach(function (wrapper) {
        if (wrapper.contains(event.target)) return;
        const toggle = wrapper.querySelector("[data-fbp-hero-select-toggle]");
        const menu = wrapper.querySelector("[data-fbp-hero-select-menu]");
        if (toggle) toggle.setAttribute("aria-expanded", "false");
        if (menu) menu.hidden = true;
      });
    });

    if (bossHotspot) {
      ["mouseenter", "focus"].forEach(function (eventName) {
        bossHotspot.addEventListener(eventName, revealBossUi);
      });
      bossHotspot.addEventListener("click", function () {
        revealBossUi();
        damageBoss();
      });
    }

    root.querySelectorAll("[data-fbp-stage-prev]").forEach(function (button) {
      button.addEventListener("click", function () {
        updateStageImage(activeHeroEdition, activeGalleryIndex - 1);
        startStageRotation();
      });
    });

    root.querySelectorAll("[data-fbp-stage-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        updateStageImage(activeHeroEdition, activeGalleryIndex + 1);
        startStageRotation();
      });
    });

    root.querySelectorAll("[data-fbp-video-trigger]").forEach(function (button) {
      button.addEventListener("click", function () {
        const videoId = button.getAttribute("data-video-id");
        const title = button.getAttribute("data-video-title") || "Final Boss video";
        if (videoId) playInlineVideo(button, videoId, title);
      });
    });

    root.addEventListener("click", function (event) {
      const jumpButton = event.target.closest("[data-fbp-scroll-to]");
      if (jumpButton && root.contains(jumpButton)) {
        event.preventDefault();
        scrollToPageSection(jumpButton.getAttribute("data-fbp-scroll-to") || "");
        return;
      }

      const toggle = event.target.closest("[data-fbp-inline-tracklist-toggle]");
      if (!toggle || !root.contains(toggle)) return;
      event.preventDefault();
      event.stopPropagation();
      inlineTracklistOpen = !inlineTracklistOpen;
      const dropdown = toggle.closest(".fbp__tracklist-dropdown");
      const panel = dropdown ? dropdown.querySelector("[data-fbp-inline-tracklist-panel]") : null;
      if (dropdown) {
        dropdown.classList.toggle("is-open", inlineTracklistOpen);
      }
      toggle.setAttribute("aria-expanded", String(inlineTracklistOpen));
      if (panel) {
        panel.hidden = !inlineTracklistOpen;
      }
    });

    root.querySelectorAll("[data-fbp-lightbox-close]").forEach(function (button) {
      button.addEventListener("click", closeLightbox);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !lightbox.hidden) closeLightbox();
    });

    root.querySelectorAll("[data-fbp-carousel-prev]").forEach(function (button) {
      button.addEventListener("click", function () {
        carouselTrack.scrollBy({
          left: -Math.max(280, carouselTrack.clientWidth * 0.85),
          behavior: "smooth",
        });
      });
    });

    root.querySelectorAll("[data-fbp-carousel-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        carouselTrack.scrollBy({
          left: Math.max(280, carouselTrack.clientWidth * 0.85),
          behavior: "smooth",
        });
      });
    });

    root.querySelectorAll("[data-fbp-copy-code]").forEach(function (button) {
      button.addEventListener("click", function () {
        const buttonPromoPanel = button.closest(".fbp__promo-panel");

        if (buttonPromoPanel === promoPanel && !secretOfferUnlocked) {
          secretOfferClicks += 1;

          if (secretOfferTimer) {
            window.clearTimeout(secretOfferTimer);
          }

          secretOfferTimer = window.setTimeout(function () {
            secretOfferClicks = 0;
          }, 6000);

          if (secretOfferClicks >= 10) {
            secretOfferClicks = 0;
            unlockSecretOffer();
          }
        }

        const code = button.getAttribute("data-code") || "";
        const originalLabel = button.textContent;
        const copyStatus = buttonPromoPanel
          ? buttonPromoPanel.querySelector("[data-fbp-copy-status]")
          : null;

        function setCopiedState(label) {
          button.textContent = label;
          window.setTimeout(function () {
            button.textContent = originalLabel;
          }, 1600);
        }

        function setCopyStatus(text) {
          if (!copyStatus) return;
          if (secretOfferUnlocked && buttonPromoPanel === promoPanel) {
            copyStatus.textContent =
              "Persistence was worth it. Bonus unlocked: 20% off with " + SECRET_BOSS_CODE + ".";
            copyStatus.classList.add("is-visible", "is-secret");
            return;
          }

          copyStatus.textContent = text;
          copyStatus.classList.toggle("is-visible", Boolean(text));
        }

        if (!code) {
          setCopiedState("Code unavailable");
          setCopyStatus("");
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              setCopiedState("Code copied");
              setCopyStatus("Code copied. Paste it at checkout.");
            },
            function () {
              setCopiedState(code);
              setCopyStatus("Use this code at checkout: " + code);
            }
          );
        } else {
          setCopiedState(code);
          setCopyStatus("Use this code at checkout: " + code);
        }
      });
    });

    root.querySelectorAll("[data-fbp-form]").forEach(function (form) {
      form.querySelectorAll("[data-fbp-quantity-decrease], [data-fbp-quantity-increase]").forEach(function (button) {
        button.addEventListener("click", function () {
          const input = form.querySelector("[data-fbp-quantity-input]");
          if (!input) return;
          const currentValue = Number.parseInt(input.value, 10);
          const current = Number.isFinite(currentValue) && currentValue > 0 ? currentValue : 1;
          const next = button.hasAttribute("data-fbp-quantity-increase")
            ? current + 1
            : Math.max(1, current - 1);
          input.value = String(next);
        });
      });

      const quantityInput = form.querySelector("[data-fbp-quantity-input]");
      if (quantityInput) {
        quantityInput.addEventListener("change", function () {
          const currentValue = Number.parseInt(quantityInput.value, 10);
          quantityInput.value = String(Number.isFinite(currentValue) && currentValue > 0 ? currentValue : 1);
        });
      }

      form.addEventListener("submit", function (event) {
        const quantityInput = form.querySelector("[data-fbp-quantity-input]");
        if (quantityInput) {
          const currentValue = Number.parseInt(quantityInput.value, 10);
          quantityInput.value = String(Number.isFinite(currentValue) && currentValue > 0 ? currentValue : 1);
        }

        if (config.mode === "preview") {
          event.preventDefault();
        }
      });
    });

    const revealObserver = "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                if (entry.target.classList.contains("fbp__section--story")) {
                  startStoryQuoteTypewriter(entry.target);
                }
                revealObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.18 }
        )
      : null;

    root.querySelectorAll(".fbp__reveal").forEach(function (node) {
      if (!revealObserver) {
        node.classList.add("is-visible");
        if (node.classList.contains("fbp__section--story")) {
          startStoryQuoteTypewriter(node);
        }
        return;
      }

      revealObserver.observe(node);
    });

    updateHeroEdition(activeHeroEdition);
    updateShowcaseEdition(activeShowcaseEdition);
    updateFooterEdition(activeFooterEdition);
    updateBossUi();
    updateCountdown();
    scrollToInitialHash();
    countdownTimer = window.setInterval(updateCountdown, 1000);

    window.addEventListener("hashchange", scrollToInitialHash);

    root.addEventListener("remove", function () {
      if (countdownTimer) window.clearInterval(countdownTimer);
      if (secretOfferTimer) window.clearTimeout(secretOfferTimer);
      if (stageRotateTimer) window.clearInterval(stageRotateTimer);
      if (storyQuoteTimer) window.clearTimeout(storyQuoteTimer);
      window.removeEventListener("hashchange", scrollToInitialHash);
    });
  }

  document.querySelectorAll(".fbp").forEach(function (root) {
    const configElement = root.querySelector(".fbp-config");
    if (!configElement) return;

    try {
      const config = JSON.parse(configElement.textContent || "{}");
      init(root, config);
    } catch (error) {
      root.innerHTML = '<div class="fbp__empty">Final Boss preview config could not be loaded.</div>';
    }
  });
})();
